const getters = {
  getFavorites: state => state.favorites,
  getAdverts: state => state.adverts
}

export default getters
